import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from 'app/core/core.module';
import { PopoverService } from 'app/core/services/popover.service';
import { MdbPopoverDirective, MdbPopoverModule } from 'mdb-angular-ui-kit/popover';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as WebHookActions from '../../features/webhook-actions'

let id = 1;
@Component({
  selector: 'app-failed-transactions-action-cell',
  standalone: true,
  imports:[FormsModule,ReactiveFormsModule,MdbSelectModule,CoreModule,CommonModule,MdbPopoverModule],
  templateUrl: './failed-transactions-action-cell.component.html',
  styleUrl: './failed-transactions-action-cell.component.scss'
})
export class FailedTransactionsActionCellComponent implements OnInit,OnDestroy {
  @Input()
  public selectedTransaction: any;
  private takeUntilSubject: Subject<any> = new Subject();
 
  constructor(
    private store:Store,
  ) {}

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }

  private _id = id++;
  get id() {
    return `FailedTransactionActionCell${this._id}`;
  }

  ngOnInit(){
  }

  resend(event){
    event.stopPropagation();

    this.store.dispatch(
      WebHookActions.resendFailedTransaction({
        webHookErrorId:this.selectedTransaction.id,
        webHookId: this.selectedTransaction.webHookId,
      })
    )

  }
}
